import React from "react"
import './index.css'
export default ({logo}) => {

    return <div className="wx-guide">
        <div className="wx-guid-top">
            <div className="wx-head wx-section">
                <img src={logo} className="wx-logo"></img>
                <span className="wx-head-product">双环时钟</span>
            </div>
            <div className="wx-section wx-need">
                申请获得以下权限
            </div>
            <div className="wx-section">
                <img src={require('../../image/checked.png').default} className="wx-checked"></img>
                <span className="wx-query">获得你的昵称和头像</span>
            </div>
        </div>
        <div className="wx-section wx-section-guide">
            <img src={require('../../image/direct.png').default} className="wx-guide-img"></img>
        </div>
    </div>
}